import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FigureEditing from './figureediting';

export default class Section extends Plugin {
  static get requires() {
    return [FigureEditing];
  }

  static get pluginName() {
    return 'Figure';
  }
}
